import React from "react";
import { NavbarCMS } from "../../components";
import { TableCategories } from "../../components/admin/Table/TableCategories";
import { useSelector } from "react-redux";

const CategoriesPage = () => {
    const setting = useSelector((state) => state?.combineReducer?.settings);
    return (
        <div className="h-full w-full">
            <NavbarCMS module={setting?.publication_categories?.navbar} />
            <TableCategories />
        </div>
    )
}

export default CategoriesPage;